import React, { useEffect, useState } from "react";
import {
  CButton,
  CFormCheck,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";

const FIELD_LABELS = {
  balance: "Balanço",
  dr: "Demonstração de Resultados",
  financing: "Financiamento",
  projectCosts: "Quadro de Investimentos",
  activityPerMarket: "Atividade por Mercado",
  indirectExportation: "Exportação Indireta",
  subImports: "Substituição de Importações",
  projectStartDate: "Data de Início do Projeto",
  projectEndDate: "Data de Fim do Projeto",
  projectPreYear: "Ano Pré-Projeto",
  projectCruiseYear: "Ano Cruzeiro",
  projectCAE: "Atividades Económicas do Projeto (CAE)",
  jobsCreation: "Criação Líquida de Emprego",
  projectIndicators: "Indicadores do Projeto",
  projectTypologies: "Atividade Económica (Aumento de Capacidade)",
};

const humanizeFieldId = (fieldId) => {
  const key = Array.isArray(fieldId) ? fieldId.join(".") : fieldId;
  if (FIELD_LABELS[key]) return FIELD_LABELS[key];

  const lastSegment = Array.isArray(fieldId) ? fieldId[fieldId.length - 1] : fieldId;
  const spaced = String(lastSegment)
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/^./, (c) => c.toUpperCase());
  return spaced;
};

const describeValue = (value) => {
  if (Array.isArray(value)) {
    return `${value.length} registo${value.length === 1 ? "" : "s"}`;
  }
  if (value === null || value === undefined || value === "") {
    return "-";
  }
  if (typeof value === "object") {
    return "Dados atualizados";
  }
  return String(value);
};

const changeKey = (change) =>
  Array.isArray(change.fieldId) ? change.fieldId.join(".") : change.fieldId;

const ImportPreviewModal = ({ visible, changes = [], onCancel, onConfirm }) => {
  const [selected, setSelected] = useState(() => new Set());

  useEffect(() => {
    if (visible) {
      setSelected(new Set(changes.map(changeKey)));
    }
  }, [visible, changes]);

  const toggleField = (key) => {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(key)) {
        next.delete(key);
      } else {
        next.add(key);
      }
      return next;
    });
  };

  const allSelected = selected.size === changes.length && changes.length > 0;

  const toggleAll = () => {
    setSelected(allSelected ? new Set() : new Set(changes.map(changeKey)));
  };

  return (
    <CModal size="lg" visible={visible} onClose={onCancel} scrollable>
      <CModalHeader>
        <CModalTitle>Campos a atualizar</CModalTitle>
      </CModalHeader>

      <CModalBody>
        <p className="text-muted">
          Selecione os campos do formulário que pretende atualizar com os
          dados do ficheiro carregado. Por defeito, todos os campos estão
          selecionados.
        </p>

        <CTable bordered small responsive>
          <CTableHead>
            <CTableRow>
              <CTableHeaderCell style={{ width: 60 }}>
                <CFormCheck
                  checked={allSelected}
                  onChange={toggleAll}
                  aria-label="Selecionar todos"
                />
              </CTableHeaderCell>
              <CTableHeaderCell>Campo</CTableHeaderCell>
              <CTableHeaderCell>Resumo</CTableHeaderCell>
            </CTableRow>
          </CTableHead>
          <CTableBody>
            {changes.map((change) => {
              const key = changeKey(change);
              return (
                <CTableRow key={key}>
                  <CTableDataCell>
                    <CFormCheck
                      checked={selected.has(key)}
                      onChange={() => toggleField(key)}
                      aria-label={`Selecionar ${key}`}
                    />
                  </CTableDataCell>
                  <CTableDataCell>{humanizeFieldId(change.fieldId)}</CTableDataCell>
                  <CTableDataCell className="text-muted">
                    {describeValue(change.value)}
                  </CTableDataCell>
                </CTableRow>
              );
            })}
          </CTableBody>
        </CTable>
      </CModalBody>

      <CModalFooter>
        <CButton color="secondary" variant="outline" onClick={onCancel}>
          Cancelar
        </CButton>
        <CButton
          color="primary"
          disabled={selected.size === 0}
          onClick={() => onConfirm(changes.filter((c) => selected.has(changeKey(c))))}
        >
          Atualizar campos selecionados
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default ImportPreviewModal;
